"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeySettingsEditionElementTags = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const prop_types_1 = __importDefault(require("prop-types"));
const types_1 = require("./types");
const fa_1 = require("react-icons/fa");
const colormap_1 = __importDefault(require("colormap"));
const d3 = __importStar(require("d3"));
const SankeySettingsEditionTagsPropTypes = {
    t: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    elementTagNameProp: prop_types_1.default.oneOf(['nodeTags', 'fluxTags', 'dataTags']).isRequired,
    elementNameProp: prop_types_1.default.oneOf(['nodes', 'links', 'none']).isRequired
};
const SankeySettingsEditionElementTags = ({ t, data, set_data, elementTagNameProp, elementNameProp }) => {
    const isNodeTags = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
    const type_tag_name = elementTagNameProp === 'dataTags' ? 'dataTags' : isNodeTags;
    const [tags_group_key, set_tags_group_key] = react_1.useState(Object.keys(data[type_tag_name]).length > 0 ? Object.keys(data[type_tag_name])[0] : '');
    const colormaps = [
        'custom',
        'jet', 'hsv', 'hot', 'cool', 'spring', 'summer', 'autumn', 'winter', 'bone',
        'copper', 'greys', 'YIGnBu', 'greens', 'YIOrRd', 'bluered', 'RdBu', 'picnic',
        'rainbow', 'portland', 'blackbody', 'earth', 'electric',
        'viridis', 'inferno', 'magma', 'plasma', 'warm', 'cool', 'rainbow-soft',
        'bathymetry', 'cdom', 'chlorophyll', 'density', 'freesurface-blue', 'freesurface-red', 'oxygen', 'par', 'phase', 'salinity', 'temperature', 'turbidity', 'velocity-blue', 'velocity-green',
        'cubehelix'
    ];
    const elementTagName = type_tag_name;
    //Permet de modifier le type de bannier pour le groupTag (si ce non Aucun)
    const handleBanner = (tags_group_key, evt) => {
        data[type_tag_name][tags_group_key].banner = evt.target.value;
        set_data(Object.assign({}, data));
    };
    // Couleur issu de : https://github.com/d3/d3-scale-chromatic
    const list_palette_color = [d3.interpolateBlues, d3.interpolateBrBG, d3.interpolateBuGn, d3.interpolatePiYG, d3.interpolatePuOr,
        d3.interpolatePuBu, d3.interpolateRdBu, d3.interpolateRdGy, d3.interpolateRdYlBu, d3.interpolateRdYlGn, d3.interpolateSpectral,
        d3.interpolateTurbo, d3.interpolateViridis, d3.interpolateInferno, d3.interpolateMagma, d3.interpolatePlasma, d3.interpolateCividis,
        d3.interpolateWarm, d3.interpolateCool, d3.interpolateCubehelixDefault, d3.interpolateRainbow, d3.interpolateSinebow];
    let element_tags = [];
    if (Object.keys(data[elementTagName]).length > 0 && tags_group_key !== '') {
        if (tags_group_key in data[elementTagName]) {
            element_tags = Object.keys(data[elementTagName][tags_group_key].tags);
        }
        else {
            console.log('tutu');
        }
    }
    // --------------------------------------------
    //add a tags to the selected groupTag
    const handleAddTagButton = () => {
        const elementTagName = type_tag_name;
        // Méthode pour incrementer idElement
        const listId = [];
        Object.keys(data[elementTagName][tags_group_key].tags).forEach(elt => listId.push(Number(elt.replace('element', ''))));
        const idElement = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        data[elementTagName][tags_group_key].tags['element' + idElement] = { name: 'étiquette' + idElement, color: '#000000', selected: true };
        const nb_tags = Object.keys(data[elementTagName][tags_group_key].tags).length;
        const colors = colormap_1.default({
            colormap: data[elementTagName][tags_group_key].color_map,
            nshades: Math.max(11, nb_tags),
            format: 'hex',
            alpha: 1
        });
        let step = 1;
        if (nb_tags < 11) {
            step = Math.round(11 / nb_tags);
        }
        Object.keys(data[elementTagName][tags_group_key].tags).forEach((tag_key, i) => data[elementTagName][tags_group_key].tags[tag_key].color = colors[i * step]);
        // if (elementTagName === 'nodeTags' && data.nodeTags[tags_group_key].banner === 'level') {
        //   Object.values(data.nodes).forEach(node=>node.dimensions[tags_group_key] = {parent_name : undefined})
        // }
        set_data(Object.assign({}, data));
    };
    //add a groupTag
    const handleAddTagGrpButton = () => {
        const elementTagName = type_tag_name;
        const elementName = elementNameProp === 'nodes' ? 'nodes' : 'links';
        // Méthode pour incrementer idGroup
        const idGroup = Object.keys(data[elementTagName]).length + 1;
        //la clé est unique grâce au timestamp mais le nom est liée au nombre de grouptag
        const k = 'tag_group_' + String(new Date().getTime());
        data[elementTagName][k] = {
            group_name: 'Étiquette Group ' + idGroup,
            show_legend: false,
            color_map: 'jet',
            tags: {},
            banner: 'multi',
            activated: true,
            siblings: []
        };
        if (elementName === 'nodes') {
            Object.values(data[elementName]).forEach(n => n.tags[k] = []);
        }
        if (Object.keys(data[elementTagName]).length === 1) {
            Object.values(data[elementName]).forEach(n => n.colorTag = Object.keys(data[elementTagName])[0]);
        }
        set_tags_group_key(k);
        set_data(Object.assign({}, data));
    };
    // Delete a tag
    const handleDelTag = (n) => {
        const elementTagName = type_tag_name;
        //const elementName = elementTagNameProp === 'nodeTags' ? 'nodes' : 'links'
        delete data[elementTagName][tags_group_key].tags[n];
        //Object.values(data[elementName]).forEach(el=> el.tags[tags_group_key] = el.tags[tags_group_key].filter((tag:string)=>tag !== n))
        set_data(Object.assign({}, data));
    };
    const getRandomInt = (max) => {
        return Math.floor(Math.random() * max);
    };
    // Delete a groupTag
    const handleDelGroupTag = (tags_group_key) => {
        const elementTagName = type_tag_name;
        const elementName = elementNameProp === 'nodes' ? 'nodes' : 'links';
        delete data[elementTagName][tags_group_key];
        Object.values(data[elementName]).forEach(n => {
            if (n.colorTag === tags_group_key) {
                n.colorTag = '';
            }
            if (elementNameProp === 'nodes') {
                delete n.tags[tags_group_key];
            }
        });
        if (Object.keys(data[elementTagName]).length > 0) {
            const lastElmt = Object.keys(data[elementTagName])[Object.keys(data[elementTagName]).length - 1];
            set_tags_group_key(lastElmt);
        }
        set_data(Object.assign({}, data));
    };
    // Switch the position of the groupTag with the one before him on the list of grouptag
    const handleUpGrpTag = (i) => {
        const elementTagName = type_tag_name;
        const listElmt = Object.keys(data[elementTagName]);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt - 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = data[elementTagName][elt];
        });
        for (const member in data[elementTagName])
            delete data[elementTagName][member];
        Object.assign(data[elementTagName], new_cat);
        set_data(Object.assign({}, data));
    };
    // Switch the position of the groupTag with the one after him on the list of grouptag
    const handleDownGrpTag = (i) => {
        const elementTagName = type_tag_name;
        const listElmt = Object.keys(data[elementTagName]);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt + 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = data[elementTagName][elt];
        });
        for (const member in data[elementTagName])
            delete data[elementTagName][member];
        Object.assign(data[elementTagName], new_cat);
        set_data(Object.assign({}, data));
    };
    const tagSetting = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                    t('Tags.GE'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                        set_tags_group_key(evt.target.value);
                        set_data(Object.assign({}, data));
                    }, value: tags_group_key }, Object.keys(data[elementTagName]).map((key, i) => react_1.default.createElement("option", { key: i, value: key }, data[elementTagName][key].group_name)))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.1' },
                            t('Tags.tooltips.pal'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", value: 'rand', onClick: () => {
                                var _a;
                                const color_selected = list_palette_color[getRandomInt(list_palette_color.length)];
                                const size_color = Object.keys(data[elementTagName][tags_group_key].tags).length;
                                for (const i in d3.range(size_color)) {
                                    data[elementTagName][tags_group_key].tags[element_tags[i]].color = (_a = d3.color(color_selected(+i / size_color))) === null || _a === void 0 ? void 0 : _a.formatHex();
                                }
                                set_data(Object.assign({}, data));
                            } },
                            react_1.default.createElement(fa_1.FaPalette, null))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.2' },
                            t('Tags.tooltips.pal_shuffle'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "dark", value: 'alea', onClick: () => {
                                const color = element_tags.map(d => {
                                    return data[elementTagName][tags_group_key].tags[d].color;
                                });
                                let size_color = color.length;
                                for (const i in d3.range(size_color)) {
                                    size_color = color.length;
                                    const color_to_select = getRandomInt(size_color);
                                    const c = color.splice(color_to_select, 1);
                                    if (c != undefined && c != null) {
                                        const v = c[0];
                                        data[elementTagName][tags_group_key].tags[element_tags[i]].color = v;
                                    }
                                }
                                set_data(Object.assign({}, data));
                            } },
                            react_1.default.createElement(fa_1.FaRandom, null))))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.3' },
                        t('Tags.tooltips.pal_std'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                            data[elementTagName][tags_group_key].color_map = evt.target.value;
                            const nb_tags = Object.keys(data[elementTagName][tags_group_key].tags).length;
                            if (evt.target.value === 'custom') {
                                return;
                            }
                            const colors = colormap_1.default({
                                colormap: evt.target.value,
                                nshades: Math.max(11, nb_tags),
                                format: 'hex',
                                alpha: 1
                            });
                            let step = 1;
                            if (nb_tags < 11) {
                                step = Math.round(11 / nb_tags);
                            }
                            Object.keys(data[elementTagName][tags_group_key].tags).forEach((tag_key, i) => data[elementTagName][tags_group_key].tags[tag_key].color = colors[i * step]);
                            set_data(Object.assign({}, data));
                        }, value: (Object.keys(data[elementTagName]).length > 0 && data[elementTagName][tags_group_key] && tags_group_key != '') ? data[elementTagName][tags_group_key].color_map : '' }, colormaps.map((cur_colormap, i) => react_1.default.createElement("option", { key: i, value: cur_colormap }, cur_colormap)))))),
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: 'sm', size: 'sm', className: 'node_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.4' },
                                t('Tags.tooltips.add'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", value: '+', onClick: handleAddTagButton },
                                react_1.default.createElement(fa_1.FaPlus, null)))),
                    react_1.default.createElement("th", null, t('Tags.Nom')),
                    elementTagName !== 'dataTags' ?
                        react_1.default.createElement("th", null, t('Tags.Visible')) : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement("th", null, t('Tags.Couleur')),
                    elementNameProp === 'nodes' ?
                        react_1.default.createElement("th", null, t('Tags.Forme')) : react_1.default.createElement(react_1.default.Fragment, null))),
            react_1.default.createElement("tbody", null, element_tags.length > 0 ? element_tags.map((tag_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.5' },
                                t('Tags.tooltips.rm'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", value: '-', onClick: () => { handleDelTag(tag_key); } },
                                react_1.default.createElement(fa_1.FaMinus, null)))),
                    react_1.default.createElement("td", { style: { 'width': '33%' } },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.6' },
                                t('Tags.tooltips.nom'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl /* size='sm' */, { id: i.toString(), type: "text", value: data[elementTagName][tags_group_key].tags[tag_key].name, onChange: (evt) => {
                                    const new_nb_element = evt.target;
                                    const name = new_nb_element.value;
                                    data[elementTagName][tags_group_key].tags[tag_key].name = name;
                                    set_data(Object.assign({}, data));
                                } }))),
                    elementTagName !== 'dataTags' ?
                        react_1.default.createElement("td", { style: { 'width': '20%' } },
                            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.7' },
                                    t('Tags.tooltips.visible'),
                                    " ") },
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, name: 'element_visible' + tag_key, checked: data[elementTagName][tags_group_key].tags[tag_key].selected, id: tag_key, type: 'switch', style: { marginRight: '0px', marginLeft: '2.5em' }, onChange: (evt) => {
                                        const new_nb_element = evt.target;
                                        const tag_key = new_nb_element.id;
                                        const visible = new_nb_element.checked;
                                        data[elementTagName][tags_group_key].tags[tag_key].selected = visible;
                                        set_data(Object.assign({}, data));
                                    } }))) : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.8', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.8' },
                                t('Tags.tooltips.couleur'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", value: data[elementTagName][tags_group_key].tags[tag_key].color, onChange: evt => {
                                    data[elementTagName][tags_group_key].tags[tag_key].color = evt.target.value;
                                    set_data(Object.assign({}, data));
                                } }))),
                    elementNameProp === 'nodes' ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.9', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.9' },
                            t('Tags.tooltips.forme'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                                data[elementTagName][tags_group_key].tags[tag_key].shape = evt.target.value;
                                set_data(Object.assign({}, data));
                            }, value: data[elementTagName][tags_group_key].tags[tag_key].shape },
                            react_1.default.createElement("option", { key: 'rect' + i, id: 'rect', value: 'rect' }, "Rectangle"),
                            react_1.default.createElement("option", { key: 'circle' + i, id: 'circle', value: 'ellipse' }, "Circle")))) :
                        (react_1.default.createElement(react_1.default.Fragment, null))));
            }) : (react_1.default.createElement(react_1.default.Fragment, null))))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, className: 'node_group_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.10', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.10' },
                                t('Tags.tooltips.add_grp'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: handleAddTagGrpButton },
                                react_1.default.createElement(fa_1.FaPlus, null)))),
                    react_1.default.createElement("th", null, t('Tags.Nom')),
                    react_1.default.createElement("th", null, t('Tags.Leg')),
                    react_1.default.createElement("th", null, t('Tags.tags')),
                    react_1.default.createElement("th", null, t('Tags.Bannière')),
                    (elementTagName != 'dataTags') ? react_1.default.createElement("th", null, t('Tags.Position')) : react_1.default.createElement(react_1.default.Fragment, null))),
            react_1.default.createElement("tbody", null, Object.keys(data[elementTagName]).map((tags_group_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.11', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.11' },
                                t('Tags.tooltips.rm_grp'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: () => handleDelGroupTag(tags_group_key) },
                                react_1.default.createElement(fa_1.FaMinus, null)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.12', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.12' },
                                t('Tags.tooltips.nom_grp'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { id: i.toString(), type: "text", value: data[elementTagName][tags_group_key].group_name, onChange: (evt) => {
                                    const new_name = evt.target.value;
                                    data[elementTagName][tags_group_key].group_name = new_name;
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.13', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.13' },
                                t('Tags.tooltips.leg_grp'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, 
                                // Permet de selection le étiquette pour l'affichage dans la légende
                                name: 'element_legend_' + tags_group_key, checked: data[elementTagName][tags_group_key].show_legend, id: tags_group_key, type: 'switch', style: { marginRight: '0px', marginLeft: '1.65em' }, onChange: (evt) => {
                                    const new_nb_element = evt.target;
                                    const tags_group_key = new_nb_element.id;
                                    const visible = new_nb_element.checked;
                                    data[elementTagName][tags_group_key].show_legend = visible;
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement("td", null, Object.keys(data[elementTagName][tags_group_key].tags).length),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.14', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.14' },
                                t('Tags.tooltips.banner'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => handleBanner(tags_group_key, evt), value: data[type_tag_name][tags_group_key].banner },
                                (elementTagName != 'dataTags') ? react_1.default.createElement("option", { key: 'none' + i, id: 'NoneBaner', value: 'none' }, t('Tags.Aucun')) : react_1.default.createElement(react_1.default.Fragment, null),
                                react_1.default.createElement("option", { key: 'one' + i, id: 'OneBaner', value: 'one' }, t('Tags.Unique')),
                                react_1.default.createElement("option", { key: 'multi' + i, id: 'MultipleBaner', value: 'multi' }, t('Tags.Multiple'))))),
                    (elementTagName != 'dataTags') ?
                        react_1.default.createElement("td", { style: { 'width': '10%' } },
                            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "button_position", size: "sm" },
                                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.15', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.15' },
                                        t('Tags.tooltips.up'),
                                        " ") },
                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleUpGrpTag(tags_group_key) },
                                        react_1.default.createElement(fa_1.FaArrowAltCircleUp, null))),
                                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tags.tooltips.16', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tags.tooltips.16' },
                                        t('Tags.tooltips.down'),
                                        " ") },
                                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleDownGrpTag(tags_group_key) },
                                        react_1.default.createElement(fa_1.FaArrowAltCircleDown, null))))) : react_1.default.createElement(react_1.default.Fragment, null)));
            }))),
        Object.keys(data[elementTagName]).length > 0 ? tagSetting : react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.SankeySettingsEditionElementTags = SankeySettingsEditionElementTags;
SankeySettingsEditionElementTags.propTypes = SankeySettingsEditionTagsPropTypes;
exports.default = null;
